import React from 'react'

const ClockIcon = () => {
  return (
    <svg viewBox="0 0 17 17"
     xmlns="http://www.w3.org/2000/svg" 
     class="css-1yltdif"
     className='h-5 w-5'>
        <path
         d="M6.023.645a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-.5v1.07a7 7 0 0 1 3.274 12.473l.6.602a.5.5 0 0 1-.706.709l-.746-.747a6.97 6.97 0 0 1-3.422.893 6.97 6.97 0 0 1-3.422-.893l-.746.746a.5.5 0 1 1-.707-.707l.602-.603A7 7 0 0 1 7.023 2.215v-1.07h-.5a.5.5 0 0 1-.5-.5Zm2.5 5a.5.5 0 0 0-1 0v3.362l-1.43 2.38a.5.5 0 0 0 .859.514l1.5-2.5a.5.5 0 0 0 .07-.256v-3.5Zm-7.64-.113A2.5 2.5 0 1 1 4.41 2.005 8.035 8.035 0 0 0 .883 5.532Zm10.753-3.527a2.5 2.5 0 1 1 3.527 3.527 8.036 8.036 0 0 0-3.527-3.527Z"
          fill="currentColor"></path></svg>
  )
}

export default ClockIcon